import { render, staticRenderFns } from "./OrgProductCouponListModal.vue?vue&type=template&id=9530fb72&scoped=true&"
import script from "./OrgProductCouponListModal.vue?vue&type=script&lang=js&"
export * from "./OrgProductCouponListModal.vue?vue&type=script&lang=js&"
import style0 from "./OrgProductCouponListModal.vue?vue&type=style&index=0&id=9530fb72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9530fb72",
  null
  
)

export default component.exports